import { useAppSelector } from '@/redux/rootReducer'
import { selectAuthUser } from '@/redux/reducers/auth.reducer'
import { isDoctor, isPDS } from '@/utils/type-guards'

export function useIsPds() {
  const authUser = useAppSelector(selectAuthUser)
  return isPDS(authUser)
}

export function useIsDoctor() {
  const authUser = useAppSelector(selectAuthUser)
  return isDoctor(authUser)
}
